<template>
  <form @submit.prevent="submit" class="sale-change-email px-5">
    <div class="d-flex justify-content-between align-items-center mb-5">
      <span class="fs-18 text-secondary">Trocar e-mail</span>
      <button class="btn text-secondary" @click="$emit('close')" type="button">
        <i class="fa fa-close" />
      </button>
    </div>

    <form-group
      v-model="form.email"
      id="email"
      type="email"
      class="mb-5"
      label="E-mail novo"
      placeholder="Digite o novo e-mail"
      :errors="errors.email"
    />

    <div class="d-flex flex-column flex-lg-row justify-content-end">
      <button
        type="button"
        class="btn order-1 order-lg-0 btn-new-secondary btn-sm btn-40 ml-lg-5"
        @click="$emit('close')"
      >
        Cancelar
      </button>
      <button
        type="submit"
        class="btn order-0 order-lg-1 btn-new-primary btn-sm btn-40 ml-lg-5 mb-5 mb-lg-0"
      >
        <loading :show="loading">Salvar</loading>
      </button>
    </div>
  </form>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    id: [Number, String]
  },
  data() {
    return {
      ...formFields(["email"]),
      loading: false
    };
  },
  methods: {
    submit() {
      this.loading = true;
      window.axios
        .put(`/scrambled/order/${this.id}`, this.form)
        .then(() => {
          this.$message.success("E-mail trocado com sucesso");
          this.$store.commit("sale/setSale", {
            ...this.sale,
            shopper_email: this.form.email
          });
          this.$emit("success");
        })
        .catch(error => {
          this.$message.error(
            get(error, "response.data.message", "Erro ao trocar e-mail")
          );
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close");
        });
    }
  },
  computed: {
    ...mapState("sale", ["sale"])
  }
};
</script>
